import { Directive, DirectiveBinding } from "vue";

interface VisibilityOptions {
  hideForRespondent?: boolean;
  hideForCandidate?: boolean;
  showOnlyForManager?: boolean;
  sensitivityLevel?: "low" | "medium" | "high";
}

export const visibilityControl: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding<VisibilityOptions>) {
    const options = binding.value || {};
    const isRespondent = binding.instance?.$props?.isRespondent || false;
    const userRole =
      binding.instance?.$store?.getters?.["user/role"] || "candidate";

    let shouldHide = false;

    // Check visibility rules
    if (options.hideForRespondent && isRespondent) {
      shouldHide = true;
    }

    if (options.hideForCandidate && userRole === "candidate") {
      shouldHide = true;
    }

    if (options.showOnlyForManager && userRole !== "manager") {
      shouldHide = true;
    }

    // Apply sensitivity level rules
    if (options.sensitivityLevel === "high" && userRole !== "manager") {
      shouldHide = true;
    }

    if (shouldHide) {
      el.style.display = "none";
      el.setAttribute("aria-hidden", "true");

      // Add a placeholder for screen readers
      const placeholder = document.createElement("div");
      placeholder.className = "visibility-placeholder";
      placeholder.setAttribute("role", "presentation");
      placeholder.textContent =
        "This information is not available for your viewing level";
      placeholder.style.display = "none";
      el.parentNode?.insertBefore(placeholder, el);
    }
  },

  updated(el: HTMLElement, binding: DirectiveBinding<VisibilityOptions>) {
    // Re-evaluate visibility on updates
    const options = binding.value || {};
    const isRespondent = binding.instance?.$props?.isRespondent || false;
    const userRole =
      binding.instance?.$store?.getters?.["user/role"] || "candidate";

    let shouldHide = false;

    if (options.hideForRespondent && isRespondent) {
      shouldHide = true;
    }

    if (options.hideForCandidate && userRole === "candidate") {
      shouldHide = true;
    }

    if (options.showOnlyForManager && userRole !== "manager") {
      shouldHide = true;
    }

    el.style.display = shouldHide ? "none" : "";
    el.setAttribute("aria-hidden", shouldHide ? "true" : "false");
  },
};

// Helper function to sanitize sensitive data
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function sanitizeForCandidate(data: any, isRespondent: boolean): any {
  if (!isRespondent) return data;

  const sanitized = { ...data };

  // Remove sensitive fields
  const sensitiveFields = [
    "internal_notes",
    "manager_comments",
    "comparison_data",
    "other_candidates",
    "salary_expectations",
    "rejection_reasons",
  ];

  sensitiveFields.forEach((field) => {
    delete sanitized[field];
  });

  return sanitized;
}
